module.exports = __webpack_public_path__ + "static/project1-mbl-e8c15abb1f2daf6f9afd62fd8dd772ac.png";